/* Umbra tile grid (sections/umbra-tile-grid.liquid).
   Hover, keyboard focus and reduced motion are handled in CSS. This file only adds what CSS cannot do:
   1. The sticky header's height, published as --tg-offset, so the grid fills exactly the screen below it.
      Measured the way snippets/umbra-snap-scroll.liquid measures it, but only on load and resize, never on
      scroll, so the section cannot change height while someone scrolls past it on a phone.
   2. Touch screens have no hover, so the first tap on a tile shows its back and the second tap follows the link
      (when the section is set to "First tap shows the back"). Tapping anywhere else turns the tile back.
   3. In the theme editor, selecting a tile in the sidebar shows its back, so text edits are visible while typing. */
(function () {
  if (!window.customElements || window.customElements.get('umbra-tile-grid')) return;

  var noHover = window.matchMedia('(hover: none)');
  var TILE = '.umbra-tg__tile.is-interactive';

  function stickyHeaderHeight() {
    var h = 0;
    var groups = document.querySelectorAll('body > .shopify-section-group-header-group');
    for (var i = 0; i < groups.length; i++) {
      var position = getComputedStyle(groups[i]).position;
      /* A header in normal flow scrolls away with the page and covers nothing */
      if (position === 'static' || position === 'relative') continue;
      h = Math.max(h, groups[i].getBoundingClientRect().height);
      for (var k = 0; k < groups[i].children.length; k++) {
        h = Math.max(h, groups[i].children[k].getBoundingClientRect().height);
      }
    }
    return Math.round(h);
  }

  class UmbraTileGrid extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.handleOutside = this.handleOutside.bind(this);
      this.handleKey = this.handleKey.bind(this);
      this.handleSelect = this.handleSelect.bind(this);
      this.handleDeselect = this.handleDeselect.bind(this);
      this.queueMeasure = this.queueMeasure.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKey);
      this.addEventListener('shopify:block:select', this.handleSelect);
      this.addEventListener('shopify:block:deselect', this.handleDeselect);
      document.addEventListener('click', this.handleOutside);
      window.addEventListener('resize', this.queueMeasure);
      window.addEventListener('load', this.queueMeasure);

      /* The theme makes its header sticky from its own script, which can run after this one, so the
         first reading is repeated once the page has settled. */
      this.measure();
      this.settle = setTimeout(this.queueMeasure, 600);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKey);
      this.removeEventListener('shopify:block:select', this.handleSelect);
      this.removeEventListener('shopify:block:deselect', this.handleDeselect);
      document.removeEventListener('click', this.handleOutside);
      window.removeEventListener('resize', this.queueMeasure);
      window.removeEventListener('load', this.queueMeasure);
      clearTimeout(this.settle);
    }

    measure() {
      this.queued = false;
      this.style.setProperty('--tg-offset', stickyHeaderHeight() + 'px');
    }

    queueMeasure() {
      if (this.queued) return;
      this.queued = true;
      requestAnimationFrame(this.measure.bind(this));
    }

    resetAll(except) {
      var open = this.querySelectorAll(TILE + '.is-flipped');
      for (var i = 0; i < open.length; i++) {
        if (open[i] !== except) open[i].classList.remove('is-flipped');
      }
    }

    show(tile) {
      this.resetAll(tile);
      tile.classList.add('is-flipped');
    }

    handleClick(event) {
      var tile = event.target.closest(TILE);
      if (!tile || !this.contains(tile)) return;
      /* A mouse or trackpad already reveals the back on hover, so a click simply follows the link. */
      if (!noHover.matches) return;

      var isLink = tile.tagName === 'A';
      if (!isLink) {
        if (tile.classList.contains('is-flipped')) {
          tile.classList.remove('is-flipped');
        } else {
          this.show(tile);
        }
        return;
      }

      if (this.dataset.touch !== 'flip') return;
      if (tile.classList.contains('is-flipped')) return;
      event.preventDefault();
      this.show(tile);
    }

    handleOutside(event) {
      if (!this.contains(event.target)) this.resetAll(null);
    }

    handleKey(event) {
      if (event.key === 'Escape') this.resetAll(null);
    }

    handleSelect(event) {
      var tile = event.target && event.target.querySelector ? event.target.querySelector(TILE) : null;
      if (tile) this.show(tile);
    }

    handleDeselect(event) {
      var tile = event.target && event.target.querySelector ? event.target.querySelector(TILE) : null;
      if (tile) tile.classList.remove('is-flipped');
    }
  }

  window.customElements.define('umbra-tile-grid', UmbraTileGrid);

  /* Coming back to the page with the browser's back button restores it from memory, tile states included. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var open = document.querySelectorAll(TILE + '.is-flipped');
    for (var i = 0; i < open.length; i++) open[i].classList.remove('is-flipped');
  });
})();
